const getBaseUrl = () => {
  const server = process.env.REACT_APP_SERVER || "";
  return server.endsWith("/") ? server.slice(0, -1) : server;
};

export const API_BASE_URL = getBaseUrl();
